import React from 'react';
import "./Components/CSS/Information.css"
import Reason from './Components/Reason';

let reasons = [
    {
        src: "https://res.cloudinary.com/blankc/image/upload/v1642857196/18449610531586788036_qamrgr.svg",
        header: "Remote Code Execution",
        p: "This Product allows the users to execute code remotely in Python"
    },
    {
        src: "https://res.cloudinary.com/blankc/image/upload/v1642857173/8189813191536298180_vop0sy.svg",
        header: "Payment And Authentication System",
        p: "Mock Payment System implemented with Stripe and Authentication with Firebase"
    },
        {
        src: "https://res.cloudinary.com/blankc/image/upload/v1642857194/13675474231555931396_izmf0u.svg",
        header: "Code Editor",
        p: "VS Code like Code Editor with settings to select themes from a range of themes"
    },
]

const Information = () => {
  return (<div className='information'>
            <div className='information-header'>
                <h2 style={{color: "#02203C"}}>Scroll down to watch Algorithms Expert in action</h2>
            </div>
            <div className='video'>
                <video src="https://res.cloudinary.com/blankc/video/upload/v1647363695/AlgoExpert_-_15_March_2022_l4sfyv.mp4" loop muted autoPlay></video>
            </div>
            <div className='information-header'>
                <h2 style={{color: "#02203C"}}>Why Algorithms Expert?</h2>
            </div>
            <div className='reason-list'>
                <Reason {...reasons[0]}></Reason>
                <Reason {...reasons[1]}></Reason>
                <Reason {...reasons[2]}></Reason>
            </div>
        </div>)
};

export default Information;
